"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateIsCommentingAllowed = calculateIsCommentingAllowed;
exports.calculateIsEditAllowed = calculateIsEditAllowed;
exports.calculateIsPrintAllowed = calculateIsPrintAllowed;
exports.sortActionsList = exports.rejectAPIPromise = exports.isValidMobileViewMode = exports.isSharedArrayBufferSupported = exports.isPositiveInt = exports.isPositiveFloat = exports.isNonEmptyString = exports.isNonEmptyObject = exports.isNonEmptyArray = exports.isMobileBrowser = exports.isInt = exports.isIOS = exports.isDocumentViewUpdateEvent = exports.isDeviceBrowser = exports.isAndroid = exports.getMappedDropinName = exports.getDocViewUpdateEventsConsolidatedList = exports.getDocViewUpdateEventTypeGroup = exports.getDOMElement = exports.getBrowserOSDeviceInfo = exports.fixedToDigits = exports.deepCopyObject = exports.compareVersion = void 0;
var _ServiceRegistry = _interopRequireDefault(require("./ServiceRegistry"));
var _Events = _interopRequireWildcard(require("../constants/Events"));
var _ViewMode = _interopRequireDefault(require("../constants/ViewMode"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ // We have global UAParser defined by dc-sdk-launcher
/* global UAParser */
function calculateIsPrintAllowed(docPermissions) {
  if (docPermissions.documentRestrictions) {
    const restrictions = docPermissions.documentRestrictions;
    return !!restrictions.printingAllowed;
  }
  return true;
}
function calculateIsCommentingAllowed(docPermissions) {
  if (docPermissions.documentRestrictions) {
    const restrictions = docPermissions.documentRestrictions;
    return !!restrictions.commentingAllowed;
  }
  return true;
}
function calculateIsEditAllowed(docPermissions, commentingOn, formFillingOn) {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  const restrictions = docPermissions.documentRestrictions;
  if (appStore.getActionConfig("preview").enableEncryptedWrite) {
    let isEditAllowed = true;
    if (restrictions) {
      isEditAllowed = !!(restrictions !== null && restrictions !== void 0 && restrictions.modifyingContentAllowed || restrictions !== null && restrictions !== void 0 && restrictions.signingAllowed);
      if (commentingOn && restrictions !== null && restrictions !== void 0 && restrictions.commentingAllowed) {
        isEditAllowed = true;
      }
      if (formFillingOn && restrictions !== null && restrictions !== void 0 && restrictions.formFillingAllowed) {
        isEditAllowed = true;
      }
    }
    return isEditAllowed;
  }
  if (docPermissions.documentSecurity && docPermissions.documentSecurity !== "None") {
    return false;
  }
  if (restrictions) {
    if (!restrictions.modifyingContentAllowed || !restrictions.signingAllowed) {
      return false;
    }
    if (commentingOn) {
      return !!restrictions.commentingAllowed;
    }
    if (formFillingOn) {
      return !!restrictions.formFillingAllowed;
    }
    return false;
  }
  return true;
}
const sortActionsList = (actionsList, toolsOrder) => {
  if (actionsList && actionsList.length > 0) {
    const actions = actionsList.filter(action => toolsOrder.indexOf(action.id) !== -1);
    return actions.sort((a, b) => toolsOrder.indexOf(a.id) - toolsOrder.indexOf(b.id));
  }
  return actionsList;
};
exports.sortActionsList = sortActionsList;
const isDeviceBrowser = () => {
  const userAgent = new UAParser();
  const deviceType = userAgent.getDevice().type;
  return !!deviceType && deviceType.match(/(phone|mobile|tablet)/i) !== null;
};
exports.isDeviceBrowser = isDeviceBrowser;
const isMobileBrowser = () => {
  const userAgent = new UAParser();
  const deviceType = userAgent.getDevice().type;
  return !!deviceType && deviceType.match(/(phone|mobile)/i) !== null;
};
exports.isMobileBrowser = isMobileBrowser;
const isIOS = () => {
  const userAgent = new UAParser();
  const os = userAgent.getOS().name;
  return os.toLowerCase() === "ios";
};
exports.isIOS = isIOS;
const isAndroid = () => {
  const userAgent = new UAParser();
  const os = userAgent.getOS().name;
  return os.toLowerCase() === "android";
};
exports.isAndroid = isAndroid;
const getBrowserOSDeviceInfo = () => {
  const userAgent = new UAParser();
  let browser = "-";
  let browserVersion = "-";
  let browserMajor = "-";
  let os = "-";
  let osVersion = "-";
  let deviceType = "-";
  const browserInfo = userAgent.getBrowser();
  if (browserInfo && browserInfo.name) {
    browser = browserInfo.name;
    browserVersion = browserInfo.version;
    browserMajor = browserInfo.major;
  }
  const osInfo = userAgent.getOS();
  if (osInfo && osInfo.name) {
    os = osInfo.name;
    osVersion = osInfo.version;
  }
  const deviceInfo = userAgent.getDevice();
  if (deviceInfo && deviceInfo.type) {
    deviceType = deviceInfo.type;
  }
  return {
    browser,
    browserVersion,
    browserMajor,
    os,
    osVersion,
    deviceType
  };
};
exports.getBrowserOSDeviceInfo = getBrowserOSDeviceInfo;
const rejectAPIPromise = code => {
  const config = _ServiceRegistry.default.getService("AppStore").getConfig();
  [_Events.default.APP_RENDERING_FAILED, _Events.InternalEvents.FILE_PREVIEW_FAILED].forEach(type => {
    if (config.isViewSDKPublic) {
      _ServiceRegistry.default.getService("EventsService").sendEvent(type, {
        code
      });
    } else {
      _ServiceRegistry.default.getService("EventHandlerService").handleEvent({
        type,
        data: {
          code
        }
      });
    }
  });
};
exports.rejectAPIPromise = rejectAPIPromise;
const isSharedArrayBufferSupported = () => {
  let isSupported = false;
  let logMessage;
  try {
    isSupported = !!window.SharedArrayBuffer;
    logMessage = `isSharedArrayBufferSupported: ${isSupported}`;
  } catch (e) {
    logMessage = "Error while checking isSharedArrayBufferSupported";
  }
  _ServiceRegistry.default.getService("LoggingService").info("AppUtil", logMessage);
  return isSupported;
};
exports.isSharedArrayBufferSupported = isSharedArrayBufferSupported;
const fixedToDigits = (data, N) => Number(Number(data).toFixed(N));
exports.fixedToDigits = fixedToDigits;
const isNonEmptyArray = arr => Array.isArray(arr) && arr.length > 0;
exports.isNonEmptyArray = isNonEmptyArray;
const isInt = value => Number.isInteger(value);

// For time being allowing int as valid float.
exports.isInt = isInt;
const isFloat = value => Number(value) === value;
const isPositiveFloat = value => isFloat(value) && value > 0;
exports.isPositiveFloat = isPositiveFloat;
const isPositiveInt = number => isInt(number) && number > 0;
exports.isPositiveInt = isPositiveInt;
const isNonNullOrUndefined = obj => obj !== null && obj !== undefined;
const isNonEmptyString = str => typeof str === "string" && str.length > 0;
exports.isNonEmptyString = isNonEmptyString;
const isNonEmptyObject = obj => typeof obj === "object" && Object.keys(obj).length > 0;
exports.isNonEmptyObject = isNonEmptyObject;
const deepCopyObject = obj => {
  const newObj = _objectSpread({}, obj);
  Object.keys(obj).forEach(key => {
    if (isNonNullOrUndefined(obj[key]) && typeof obj[key] === "object" && !obj[key].length) {
      newObj[key] = _objectSpread(_objectSpread({}, newObj[key]), deepCopyObject(obj[key]));
    }
  });
  return newObj;
};
exports.deepCopyObject = deepCopyObject;
const getDOMElement = () => window.document.getElementById("dc-view-sdk-bundle");
exports.getDOMElement = getDOMElement;
const isValidMobileViewMode = viewMode => !![_ViewMode.default.SINGLE_PAGE, _ViewMode.default.CONTINUOUS].find(e => e === viewMode);
exports.isValidMobileViewMode = isValidMobileViewMode;
const getMappedDropinName = name => {
  switch (name) {
    case "editpdf":
      return "verb-edit-pdf-viewer";
    default:
      return name;
  }
};
exports.getMappedDropinName = getMappedDropinName;
const trimArray = arr => {
  const len = arr.length;
  let i;
  for (i = len - 1; i >= 0; i -= 1) {
    if (arr[i] > 0) {
      break;
    }
  }
  arr.splice(i + 1);
};

/**
 * This function returns value in the form (v1 - v2)
 *
 * 1) If v1 > v2, return 1
 * 2) If v1 < v2, return -1
 * 3) If v1 = v2, return 0
 *
 * - compareVersion("0.20.7", "0.20.8") = -1
 * - compareVersion("0.20.9", "0.20.8") = 1
 * - compareVersion("0.20.08", "0.20.8") = 0
 *
 * @param {String} version1
 * @param {String} version2
 */
const compareVersion = (version1, version2) => {
  const v1 = version1.split(".").map(x => parseInt(x, 10));
  const v2 = version2.split(".").map(x => parseInt(x, 10));
  trimArray(v1);
  trimArray(v2);
  const iterations = Math.min(v1.length, v2.length);
  for (let i = 0; i < iterations; i += 1) {
    if (v1[i] > v2[i]) return 1;
    if (v1[i] < v2[i]) return -1;
  }
  if (v1.length === v2.length) {
    return 0;
  }
  if (v1.length < v2.length) {
    return -1;
  }
  return 1;
};
exports.compareVersion = compareVersion;
const getDocViewUpdateEventsConsolidatedList = () => {
  const eventTypes = Object.keys(_Events.DOCUMENT_VIEW_UPDATE_EVENTS_LIST);
  const eventList = eventTypes.reduce((acc, curr) => [...acc, ..._Events.DOCUMENT_VIEW_UPDATE_EVENTS_LIST[curr]], []);
  return eventList;
};
exports.getDocViewUpdateEventsConsolidatedList = getDocViewUpdateEventsConsolidatedList;
const getDocViewUpdateEventTypeGroup = eventType => Object.keys(_Events.DOCUMENT_VIEW_UPDATE_EVENTS_LIST).find(type => _Events.DOCUMENT_VIEW_UPDATE_EVENTS_LIST[type].includes(eventType)) || null;
exports.getDocViewUpdateEventTypeGroup = getDocViewUpdateEventTypeGroup;
const isDocumentViewUpdateEvent = eventType => {
  const eventList = getDocViewUpdateEventsConsolidatedList();
  return eventList.includes(eventType);
};
exports.isDocumentViewUpdateEvent = isDocumentViewUpdateEvent;